module.exports = function($scope, value, label, max) {
  $scope.value = value;
  $scope.label = label;
  $scope.max = max;

  $scope.submit = function() {
    $scope.closeThisDialog({type: 'submit', value: $scope.value });
  }

  $scope.cancel = function() {
    $scope.closeThisDialog({type: 'cancel'});
  }
}
